//GeneratorFlag:[NoChange]
import City from './city';

export default {City}
export{City}